<div class="title">
    <ng-content></ng-content>
</div>